import React from 'react';
import logo from './logo.svg';
import './App.css';
import Landing from "./Component/Landing";
import { BrowserRouter, Routes, Route } from "react-router-dom";

function App() {
  return (
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
        </Routes>
      </BrowserRouter>
  );
}

export default App;
